import { ISearchMedicationsProps } from '@interfaces/medications';

export const buildSearchMedicationsPayload = ({ page, search }: ISearchMedicationsProps) => ({
  pagination: {
    page,
    pageSize: Number(process.env.REACT_APP_DEFAULT_PAGE_SIZE) || 10,
  },
  search,
  sort: {
    active: '',
    direction: '',
  },
});
